<template>
  <section class="page-container">
    <!--工具条-->
    <div ref="toolbar" class="toolbar">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.sku" placeholder="款号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.name" placeholder="名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-cascader
            v-model="filters.catIds"
            style="width: 350px"
            placeholder="分类"
            :options="categories"
            filterable
            :props="{
              expandTrigger: 'hover',
              value: 'id',
              label: 'name',
              multiple: false,
              checkStrictly: true,
            }"
          ></el-cascader>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.status" placeholder="状态" clearable>
            <el-option :value="1" label="上架" />
            <el-option :value="2" label="下架" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="list">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd">新增</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--列表-->
    <div ref="mainContent" :style="{ height: mainHeight }">
      <el-table
        v-loading="listLoading"
        height="100%"
        :data="results"
        highlight-current-row
        border
        stripe
        size="mini"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="expand">
          <template slot-scope="scope">
            <el-descriptions :column="4" size="mini" border style="margin: 0 10px">
              <el-descriptions-item>
                <template slot="label"> 尺码表 </template>
                <el-image
                  v-if="scope.row.sizeImage"
                  :src="scope.row.sizeImage"
                  :preview-src-list="[scope.row.sizeImage]"
                  fit="cover"
                  style="width: 50px; height: 50px"
                />
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label"> 详情 </template>
                <el-image
                  v-if="scope.row.detail && scope.row.detail.length"
                  :src="scope.row.detail[0]"
                  :preview-src-list="scope.row.detail"
                  fit="cover"
                  style="width: 50px; height: 50px"
                />
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label"> 类型Condition </template>
                {{ scope.row.typeCondition }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label"> 鉴定结果 </template>
                {{ scope.row.appraisalResult }}
              </el-descriptions-item>
            </el-descriptions>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column prop="sku" label="款号"></el-table-column>
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column prop="images" label="图片">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.image"
              :src="scope.row.image"
              :preview-src-list="scope.row.images"
              fit="cover"
              style="width: 50px; height: 50px"
            />
          </template>
        </el-table-column>
        <el-table-column prop="cats" label="分类" width="300">
          <template slot-scope="scope">
            <el-popover
              v-for="(cats, index) in scope.row.cats"
              :key="index"
              placement="top"
              trigger="hover"
            >
              <div>
                <span v-for="(cat, i) in cats" :key="cat.id"
                  >{{ cat.name }} <span v-if="i < cats.length - 1">&nbsp;&gt;&nbsp;</span></span
                >
              </div>
              <el-tag
                slot="reference"
                size="mini"
                effect="dark"
                style="margin-right: 5px; margin-bottom: 5px"
              >
                {{ cats[cats.length - 1].name }}
              </el-tag>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 1">上架</span>
            <span v-else-if="scope.row.status === 2">下架</span>
            <span v-else>/</span>
          </template>
        </el-table-column>
        <el-table-column prop="minPrice" label="价格">
          <template slot-scope="scope">
            {{ scope.row.minPrice }} - {{ scope.row.maxPrice }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-dropdown type="primary" @command="handleCommand">
              <el-button type="primary" size="mini">
                操作<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  :command="{
                    type: 'edit',
                    index: scope.$index,
                    data: scope.row,
                  }"
                  >编辑</el-dropdown-item
                >
                <el-dropdown-item
                  :command="{
                    type: 'delete',
                    index: scope.$index,
                    data: scope.row,
                  }"
                  >删除</el-dropdown-item
                >
                <el-dropdown-item
                  :command="{
                    type: 'productSize',
                    index: scope.$index,
                    data: scope.row,
                  }"
                  >尺码</el-dropdown-item
                >
                <el-dropdown-item
                  :command="{
                    type: 'productItems',
                    index: scope.$index,
                    data: scope.row,
                  }"
                  >子商品</el-dropdown-item
                >
                <el-dropdown-item
                  :command="{
                    type: 'sealHistories',
                    index: scope.$index,
                    data: scope.row,
                  }"
                  >销售记录</el-dropdown-item
                >
                <el-dropdown-item
                  :command="{
                    type: 'autoTask',
                    index: scope.$index,
                    data: scope.row,
                  }"
                  >添加黄牛订单</el-dropdown-item
                >
                <el-dropdown-item
                  :command="{
                    type: 'recommendForYou',
                    index: scope.$index,
                    data: scope.row,
                  }"
                  >RecommendForYou</el-dropdown-item
                >
                <el-dropdown-item
                  :command="{
                    type: 'push',
                    index: scope.$index,
                    data: scope.row,
                  }"
                  >推送通知</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <div class="footer-bar">
      <el-button type="primary" plain size="mini" @click="handleSelectedRows"
        >已选择 {{ selectedRows.length || 0 }}</el-button
      >
      <my-pagination
        ref="pagebar"
        :page="page"
        @current-change="handlePageChange"
        @size-change="handleLimitChange"
      />
    </div>
    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      :close-on-click-modal="false"
      width="80%"
    >
      <el-form :key="addFormKey" ref="addForm" :model="addForm" label-width="120px">
        <el-form-item label="款号">
          <el-input v-model="addForm.sku"></el-input>
        </el-form-item>
        <el-form-item label="名称">
          <el-input v-model="addForm.name"></el-input>
        </el-form-item>
        <el-form-item label="图片">
          <batch-image-upload v-model="addForm.images" />
        </el-form-item>
        <el-form-item label="分类">
          <el-cascader
            v-model="addForm.catIds"
            style="width: 550px"
            :options="categories"
            filterable
            :props="{
              expandTrigger: 'hover',
              value: 'id',
              label: 'name',
              multiple: true,
              checkStrictly: false,
            }"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="状态condition">
          <el-input v-model="addForm.typeCondition"></el-input>
        </el-form-item>
        <el-form-item label="鉴定结果">
          <el-input v-model="addForm.appraisalResult"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="addForm.status" placeholder="状态">
            <el-option :value="1" label="上架" />
            <el-option :value="2" label="下架" />
          </el-select>
        </el-form-item>
        <el-form-item label="图文详情">
          <batch-image-upload v-model="addForm.detail" />
        </el-form-item>
        <el-form-item label="尺码表">
          <image-upload v-model="addForm.sizeImage" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="addLoading" @click.native="addSubmit">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      :close-on-click-modal="false"
      width="80%"
    >
      <el-form :key="editFormKey" ref="editForm" :model="editForm" label-width="120px">
        <el-input v-model="editForm.id" type="hidden"></el-input>
        <el-form-item label="款号">
          <el-input v-model="editForm.sku"></el-input>
        </el-form-item>
        <el-form-item label="名称">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>
        <el-form-item label="图片">
          <batch-image-upload v-model="editForm.images" />
        </el-form-item>
        <el-form-item label="分类">
          <el-cascader
            v-model="editForm.catIds"
            style="width: 550px"
            :options="categories"
            filterable
            :props="{
              expandTrigger: 'hover',
              value: 'id',
              label: 'name',
              multiple: true,
              checkStrictly: false,
            }"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="状态condition">
          <el-input v-model="editForm.typeCondition"></el-input>
        </el-form-item>
        <el-form-item label="鉴定结果">
          <el-input v-model="editForm.appraisalResult"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="editForm.status" placeholder="状态">
            <el-option :value="1" label="上架" />
            <el-option :value="2" label="下架" />
          </el-select>
        </el-form-item>
        <el-form-item label="图文详情">
          <batch-image-upload v-model="editForm.detail" />
        </el-form-item>
        <el-form-item label="尺码表">
          <image-upload v-model="editForm.sizeImage" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="editLoading" @click.native="editSubmit">提交</el-button>
      </div>
    </el-dialog>

    <!--添加黄牛订单-->
    <el-dialog title="添加黄牛订单" :visible.sync="autoTaskVisible" :close-on-click-modal="false">
      <el-form :key="autoTaskFormKey" ref="autoTask" :model="autoTaskForm" label-width="180px">
        <el-form-item label="商品ID">
          <el-input v-model="autoTaskForm.productId" readonly></el-input>
        </el-form-item>
        <el-form-item label="尺码">
          <!-- <el-input v-model="autoTaskForm.size"></el-input> -->
          <el-select
            v-model="autoTaskForm.sizes"
            multiple
            filterable
            allow-create
            default-first-option
            placeholder="尺码"
          >
          </el-select>
        </el-form-item>
        <el-form-item label="价格">
          <el-input v-model="autoTaskForm.price" placeholder="系统会自动上下浮动"></el-input>
        </el-form-item>
        <el-form-item label="订单数量">
          <el-input-number v-model="autoTaskForm.count"></el-input-number>
        </el-form-item>
        <el-form-item label="多少分钟内添加完成">
          <el-input-number v-model="autoTaskForm.minutes"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="autoTaskVisible = false">取消</el-button>
        <el-button type="primary" :loading="autoTaskLoading" @click.native="submitAutoTask"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <product-item ref="productItem" />
    <product-size ref="productSize" />
    <product-seal-history ref="productSealHistory" />
    <add-recommend-for-you ref="recommendForYou" />
    <batch-product-handle ref="batchProductHandle" @success="list" />
  </section>
</template>

<script>
import MyPagination from "@/components/MyPagination";
import BatchImageUpload from "@/components/BatchImageUpload";
import ImageUpload from "@/components/ImageUpload";
import ProductItem from "../product-item/index";
import ProductSize from "../product-size/index";
import ProductSealHistory from "../product-seal-history/index";
import AddRecommendForYou from "./AddRecommendForYou";
import BatchProductHandle from "./BatchProductHandle";
import mainHeight from "@/utils/mainHeight";
export default {
  name: "Product",
  components: {
    MyPagination,
    BatchImageUpload,
    ImageUpload,
    ProductItem,
    ProductSize,
    ProductSealHistory,
    AddRecommendForYou,
    BatchProductHandle,
  },
  data() {
    return {
      mainHeight: "300px",
      results: [],
      listLoading: false,
      page: {},
      filters: {},
      selectedRows: [],

      addFormKey: null,
      addForm: {},
      addFormVisible: false,
      addLoading: false,

      editFormKey: null,
      editForm: {},
      editFormVisible: false,
      editLoading: false,

      autoTaskFormKey: null,
      autoTaskForm: {},
      autoTaskVisible: false,
      autoTaskLoading: false,

      categories: [],
    };
  },
  mounted() {
    mainHeight(this);
    this.list();
    this.loadCategories();
  },
  methods: {
    handleCommand(cmd) {
      switch (cmd.type) {
        case "edit":
          this.handleEdit(cmd.index, cmd.data);
          break;
        case "delete":
          this.deleteSubmit(cmd.index, cmd.data);
          break;
        case "productItems":
          this.showProductItem(cmd.index, cmd.data);
          break;
        case "productSize":
          this.showProductSize(cmd.index, cmd.data);
          break;
        case "sealHistories":
          this.showSealHistories(cmd.index, cmd.data);
          break;
        case "autoTask":
          this.showAutoTask(cmd.data.id);
          break;
        case "recommendForYou":
          this.recommendForYou(cmd.data.id);
          break;
        case "push":
          this.push(cmd.data.id);
          break;
        default:
          break;
      }
    },
    async loadCategories() {
      this.categories = await this.axios.get("mall:/api/admin/product-category/tree");
    },
    async list() {
      this.listLoading = true;
      const params = Object.assign(this.filters, {
        page: this.page.page,
        limit: this.page.limit,
      });
      if (this.filters.catIds && this.filters.catIds.length) {
        params.catId = this.filters.catIds[this.filters.catIds.length - 1];
      }
      try {
        const data = await this.axios.form("mall:/api/admin/product/list", params);
        this.results = data.results;
        this.page = data.page;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.listLoading = false;
      }
    },
    handleAdd() {
      this.addFormKey = new Date().getTime();
      this.addForm = {};
      this.addFormVisible = true;
    },
    async addSubmit() {
      this.addLoading = true;
      try {
        await this.axios.post("mall:/api/admin/product/create", this.addForm);
        this.$message({ message: "提交成功", type: "success" });
        this.addFormVisible = false;
        await this.list();
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.addLoading = false;
      }
    },
    async handleEdit(index, row) {
      try {
        const data = await this.axios.get("mall:/api/admin/product/" + row.id);
        this.editFormKey = new Date().getTime();
        this.editForm = Object.assign({}, data);
        this.editFormVisible = true;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    async editSubmit() {
      this.editLoading = true;
      try {
        await this.axios.post("mall:/api/admin/product/update", this.editForm);
        await this.list();
        this.editFormVisible = false;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.editLoading = false;
      }
    },
    async deleteSubmit(index, row) {
      const me = this;
      this.$confirm("Are you sure delete?", "提示", {
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
        type: "warning",
      })
        .then(() => {
          this.axios
            .delete(`mall:/api/admin/product/${row.id}`)
            .then((data) => {
              me.$message({ message: "删除成功", type: "success" });
              me.list();
            })
            .catch((rsp) => {
              me.$elnotify.error({ title: "error ", message: rsp.message });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    showProductItem(index, row) {
      this.$refs.productItem.show(row.id);
    },
    showProductSize(index, row) {
      this.$refs.productSize.show(row.id);
    },
    showSealHistories(index, row) {
      this.$refs.productSealHistory.show(row.id);
    },
    async handlePageChange(val) {
      this.page.page = val;
      await this.list();
    },
    async handleLimitChange(val) {
      this.page.limit = val;
      await this.list();
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    showAutoTask(productId) {
      this.autoTaskFormKey = new Date().getTime();
      this.autoTaskForm = {
        productId: productId,
        count: 5,
        minutes: 1440,
      };
      this.autoTaskVisible = true;
    },
    async submitAutoTask() {
      this.autoTaskLoading = true;
      try {
        await this.axios.form("mall:/api/admin/buyer-order/addSealHistories", {
          ...this.autoTaskForm,
          sizes: this.autoTaskForm.sizes.join(","),
        });
        await this.list();
        this.autoTaskForm = {};
        this.autoTaskVisible = false;
        this.$notify.success("Success");
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.autoTaskLoading = false;
      }
    },
    async recommendForYou(productId) {
      await this.$refs.recommendForYou.show(productId);
    },
    push(productId) {
      const me = this;
      this.$prompt("是否推送该商品，推送后所有app用户都会收到该消息!!!", "请确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        inputPlaceholder: "推送内容",
        inputValidator: function (value) {
          if (!value) {
            return "请输入推送内容";
          }
        },
      })
        .then(({ value }) => {
          me.axios
            .form("base:/api/admin/push/product", { productId, alert: value })
            .then(() => {
              me.$message({
                type: "success",
                message: "推送成功!",
              });
            })
            .catch((e) => {
              me.$message({
                type: "error",
                message: e.message || e,
              });
            });
        })
        .catch(() => {
          me.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    handleSelectedRows() {
      console.log(this.selectedRows);
      if (!this.selectedRows || !this.selectedRows.length) {
        this.$notify.error("暂未选择任何商品");
        return;
      }
      this.$refs.batchProductHandle.show(this.selectedRows);
    },
  },
};
</script>

<style lang="scss" scoped>
.footer-bar {
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
}
</style>
